<template>
  <div
    class="cookies-wrapper"
    :class="isClosed ? 'cookies-wrapper__close' : ''"
  >
    <div class="container d-flex justify-content-center flex-wrap">
      <div class="left text-center">
        {{ $t('pages.accept-cookies.alert-title') }}
        <router-link :to="{ name: 'cookies-policy' }">
          {{ $t('pages.accept-cookies.cookies') }}.
        </router-link>
      </div>
      <div class="right">
        <div>
          <span
            class="btn-accept"
            @click="accept"
          >
            {{ $t('pages.accept-cookies.accept') }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isClosed: false
    }
  },
  mounted() {
    if(localStorage.getItem('acceptedCookies')) {
      this.isClosed = (localStorage.getItem('acceptedCookies'));
    }
  },
  methods: {
    accept() {
      localStorage.setItem('acceptedCookies', true);
      this.isClosed = true;
    }
  }
}
</script>

<style lang="scss">
  .cookies-wrapper {
    background: #2e363f;
    width: 100%;
    position: fixed;
    z-index: 10;
    padding: 5px;
    transition: all 1s ease-out;
    bottom: 0;
    &__close {
        bottom: -105px;
    }
    .left {
      color: white;
      font-size: 0.8rem;
      text-align: left;
      a {
        color: white;
        font-weight: 600;
        text-decoration: underline;
      }
    }
    .btn-accept {
      color: white;
      cursor: pointer;
      border-radius: 3px;
      background: #009090;
      padding: 4px 10px;
      font-size: 0.9rem;
      &:hover {
        background: #005252;
      }
    }
    @media screen and (min-width: 767px) {
      .left {
        margin-right: 25px;
      }
    }
  }
</style>